import * as React from "react";
import { Subscribe } from "unstated";

import { AppContainer } from "../../containers/App.container";
import styled from "../../styled-components";

const Wrapper = styled.div`
  background: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

interface IAppLayoutProps {
  children?: any;
}

interface IContainerProps {
  navOpen: boolean;
  setNavOpen: (navOpen: boolean) => void;
}

class AppLayout extends React.Component<IAppLayoutProps & IContainerProps, {}> {
  public render() {
    const { children, navOpen, setNavOpen } = this.props;

    return (
      <Wrapper
        onClick={() => {
          if (navOpen) {
            setNavOpen(false);
          }
        }}
      >
        <>{children}</>
      </Wrapper>
    );
  }
}

export default (props: IAppLayoutProps) => (
  <Subscribe to={[AppContainer]}>
    {(app: AppContainer) => (
      <AppLayout
        {...props}
        navOpen={app.state.navOpen}
        setNavOpen={app.setNavOpen}
      />
    )}
  </Subscribe>
);



// WEBPACK FOOTER //
// ./src/components/AppLayout/AppLayout.tsx